import React, { useState } from "react";
import _ from "lodash";
import { DateRangePicker } from "@progress/kendo-react-dateinputs";
import * as Convert from "../../utils/convert";
import { fieldFormat } from "../../utils/helper";
import PropTypes from "prop-types";

/**
 * Edit EditDateRange cell component
 * @module
 * @param {func} onChange - Function invoked on change
 * @param {string} dataItem - Data item
 * @param {string} field - Field
 * @param {string} className - TD Class name
 * @param {number} colSpan - Number of columns which cell expands to
 * @param {object} style - Style
 * @param {number} columnIndex - Column index
 * @param {number} level - Level
 * @param {func} render - Render function
 */
export const editDateRangeCell = ({ isValueChanged }) => {
  const EditDateRangeCell = (props) => {
    let timeout = null;
    const { onChange, dataItem, field, tdProps, format, isInEdit } = props;

    const [value, setValue] = useState(_.get(dataItem, field.split(".")));

    const handleChange = (e) => {
      setValue(e.target.value);

      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }

      //TODO: test bez timeout a state-u
      timeout = setTimeout(() => {
        onChange({
          dataItem: dataItem,
          field: field,
          syntheticEvent: e.syntheticEvent,
          value: value,
        });

        timeout = null;
      }, 1000);
    };

    // componentDidUpdate(prevProps, prevState) {
    //   const { field, dataItem } = props;
    //   const dataValue = _.get(dataItem, field.split('.'));
    //   const prevDataValue = _.get(prevProps.dataItem, prevProps.field.split('.'));
    //   if (prevDataValue !== dataValue) {
    //     setState({ value: dataValue });
    //   }
    // }

    const newFormat = format ? fieldFormat(format) : "dd.MM.y";
    const dataValue = value;
    return <td
      {...tdProps} className={`${tdProps.className} ${isValueChanged && isValueChanged(dataItem, field) ? "k-state-changed" : ""}`} tabIndex={0}
    >
      {isInEdit ? (
        <DateRangePicker onChange={handleChange} value={dataValue} format={newFormat} />
      ) : (
        `${Convert.dateToStr(dataValue?.start, newFormat)}-${Convert.dateToStr(dataValue?.end, newFormat)}`
      )}
    </td>
  };

  EditDateRangeCell.propTypes = {
    onChange: PropTypes.func,
    dataItem: PropTypes.object,
    field: PropTypes.string,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    style: PropTypes.object,
    columnIndex: PropTypes.number,
    level: PropTypes.number,
    render: PropTypes.func,
  };

  return EditDateRangeCell;
};
